//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";
import MoreVert from "@material-ui/icons/MoreVert";
import ViewList from "@material-ui/icons/ViewList";

// core components
import HeaderLinks from "./HeaderLinks";
import CustomButton from "components/CustomButtons/Button.jsx";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";

const Header = ({ ...props }) => {
  const makeBrand = () => {
    let name;
    props.routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      }
      if (prop.path === props.location.pathname) {
        name = prop.name;
      }
      return null;
    });
    return name;
  };
  const { classes, color } = props;
  const appBarClasses = cx({ [" " + classes[color]]: color });
  const sidebarMinimize = classes.sidebarMinimize;
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <CustomButton color="white" justIcon onClick={props.sidebarMinimize} round>
                <ViewList className={classes.sidebarMiniIcon} />
              </CustomButton>
            ) : (
              <CustomButton color="white" justIcon onClick={props.sidebarMinimize} round>
                <MoreVert className={classes.sidebarMiniIcon} />
              </CustomButton>
            )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button className={classes.title} href="#">
            {makeBrand()}
          </Button>
        </div>
        <Hidden implementation="css" smDown>
          <HeaderLinks />
        </Hidden>
        <Hidden mdUp>
          <IconButton
            aria-label="open drawer"
            className={classes.appResponsive}
            color="inherit"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  handleDrawerToggle: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  miniActive: PropTypes.bool,
  routes: PropTypes.array,
  sidebarMinimize: PropTypes.func.isRequired,
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Header/Header.jsx